import moment from "moment";

import { BaseValidation, ErrorObject } from "@vuelidate/core";
import { helpers } from "@vuelidate/validators";

export function firstErrorMessage(errorObject: BaseValidation) {
  if (!errorObject || errorObject?.$errors.length < 1) {
    return undefined;
  }
  const firstError = errorObject?.$errors[0];
  if (!firstError) return undefined;
  return `${errorObject.$errors[0]?.$message}`;
}

export function findByName(validator: ErrorObject[], name: string) {
  if (!validator) return "";
  let errorFound = { $message: "" };
  if (validator.find) {
    errorFound = validator.find((err) => err.$property == name);
  }
  if (!errorFound) return undefined;
  return `${errorFound.$message}`;
}

export function dayMustBeAfterOrEqual(field, message) {
  return helpers.withMessage(message, (inputDate, vm) => {
    const targetDate = vm.value?.[field] ?? vm[field];
    if (!inputDate || !targetDate) return true;
    return moment(inputDate)
      .utc()
      .isSameOrAfter(moment(targetDate).utc(), "day");
  });
}

export function dayMustBeBeforeOrEqual(field, message) {
  return helpers.withMessage(message, (inputDate, _sibling, vm) => {
    const targetDate = vm.value?.[field] ?? vm[field];
    if (!inputDate || !targetDate) return true;
    return moment(inputDate)
      .utc()
      .isSameOrBefore(moment(targetDate).utc(), "day");
  });
}

export function mustNotBeFutureDate(message) {
  return helpers.withMessage(message, (value) => {
    if (!value) return true;
    return moment(value).isSameOrBefore(moment());
  });
}
